import { registerPlugin } from '@capacitor/core';

// Plugin Capacitor in-project de output protection (anti screenshot/gravação),
// espelha o padrão do VxlBatchDownloader. Ativo APENAS na tela de aula —
// StudentClass liga no mounted e desliga ao sair (beforeRouteLeave/destroyed).
//
// Contrato:
//   setProtection({ enabled }) -> Promise<void>
//     - Android: WindowManager.FLAG_SECURE on/off. O sistema RECUSA o screenshot
//       e mostra preto na gravação de tela + blanka o thumbnail do multitarefa.
//       Cobre a WebView inteira (incl. o <video>). Efeito colateral esperado:
//       bloqueia espelhamento de tela do SO (Miracast/screen-mirror) enquanto on.
//     - iOS: liga/desliga observadores. NÃO bloqueia screenshot (impossível sem
//       DRM). Cobre a tela com overlay preto opaco quando detecta gravação/
//       espelhamento (UIScreen.isCaptured) e borra a tela no app-switcher.
//
// Sem fallback web; no-op gracioso (callers usam try/catch). Idempotente.
//
// Eventos (iOS, opcionais — não emitidos no Android):
//   'screenCaptured'  -> { captured: boolean }   (gravação/mirroring começou/parou)
//   'screenshotTaken' -> null                      (detectado DEPOIS do print)

export const VxlScreenGuard = registerPlugin('VxlScreenGuard', {});

// Escape hatch de BUILD pra teste interno: com VUE_APP_ALLOW_SCREEN_CAPTURE=true
// a proteção nunca é ligada, e a equipe consegue tirar print/gravar a tela pra
// reportar bug. Fail-closed: ausente ou qualquer outro valor = proteção ATIVA,
// então staging e produção ficam protegidos sem depender de ninguém configurar.
// O gate mora aqui (e não no StudentClass) pra que qualquer call site futuro
// herde o comportamento em vez de reintroduzir o furo.
export const SCREEN_CAPTURE_ALLOWED = process.env.VUE_APP_ALLOW_SCREEN_CAPTURE === 'true';

if (SCREEN_CAPTURE_ALLOWED) {
  console.warn(
    '[screenGuard] VUE_APP_ALLOW_SCREEN_CAPTURE=true — proteção de tela DESLIGADA ' +
    '(screenshot e gravação liberados). Build de teste interno; NÃO usar em produção.'
  );
}

// Liga/desliga a proteção respeitando o gate de build. Use SEMPRE esta função em
// vez de VxlScreenGuard.setProtection direto. No-op gracioso fora do nativo.
export function setScreenProtection (enabled) {
  const effective = SCREEN_CAPTURE_ALLOWED ? false : Boolean(enabled);
  return VxlScreenGuard.setProtection({ enabled: effective }).catch(() => {});
}

export default VxlScreenGuard;
